import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidEmail } from '../../../../lib/validation';

export function useInstanceInfoErrors(name: string, email: string) {
  const { t } = useTranslation('instances');
  return useMemo(
    () => ({
      name: !name.trim() && !email.trim() ? t('edit.errors.atLeastOneField') : null,
      email: !email.trim()
        ? t('create.errors.emailRequired')
        : !isValidEmail(email.trim())
          ? t('create.errors.emailInvalid')
          : null,
    }),
    [name, email, t],
  );
}
